<template>
    <modal v-if="!loading" @close="resetWindow" :large="true" :class="['reservation-modal', 'dark-top']">
        <div slot="title">
            <template v-if="!isReschedule">
                <h2>Select a product</h2>
            </template>
            <template v-else>
                <h2>Reschedule your reservation</h2>
                <div class="radius-large p-2 bg-color-6 d-inline-block normal">
                    Current reservation has ticket #{{ getClonedReservation.id }}
                </div>
            </template>

            <add-filters
                :newReservationSetup="getNewReservationSetup"
                :paxTotal="paxTotal"
                @toggleAvailability="toggleAvailability">
            </add-filters>
        </div>

        <div slot="body">
            <availability :opened="isOpened" @closeAvailability="closeAvailability" :newReservationSetup="getNewReservationSetup"></availability>

            <template v-if="!isReschedule">
                <products-scroller :categories="getCategories" :newReservationSetup="getNewReservationSetup"></products-scroller>
            </template>

            <timeline-scroller></timeline-scroller>

            <events @addedEvent="addedEvent" :isReschedule="isReschedule"></events>
        </div>

        <div slot="footer">
            <button type="button" class="btn cancel wider" @click="cancelReservation">Cancel</button>

            <template v-if="!isReschedule">
                <button type="button" class="btn ok wider" @click="book" :disabled="!buttonEnabled || isBooking">Book</button>
            </template>
            <template v-else>
                <button
                    type="button"
                    class="btn action wider"
                    @click="reschedule"
                    :disabled="!buttonEnabled || isBooking">
                    Reschedule
                </button>
            </template>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'
    import AddFilters from '@/components/reservations/AddFilters'
    import ProductsScroller from '@/components/reservations/ProductsScroller'
    import TimelineScroller from '@/components/reservations/TimelineScroller'
    import Events from '@/components/reservations/Events'
    import Availability from '@/components/reservations/Availability'

    export default {
        data: function() {
            return {
                event: null,
                isOpened: false,
                isReschedule: false,
                loading: true,
                isBooking: false,
            }
        },
        created: function() {
            this.init();
        },
        computed: {
            ...mapGetters([
                'getNewReservationSetup',
                'getSelectedReservation',
                'getClonedReservation',
                'getEvents',
                'getCategories',
                'account',
            ]),
            buttonEnabled: function() {
                return (this.event) ? true : false;
            },
            paxTotal: function() {
                return 0;
            },
        },
        methods: {
            ...mapActions([
                'initEvents',
                'rescheduleReservation',
                'resetLastSavedReservation',
                'resetSelectedReservation',
                'resetNewReservationSetup',
                'updateClonedReservation',
                'resetClonedReservation',
                'updateReservation',
                'addReservation',
                'closeModal',
            ]),
            async init() {
                if (this.getSelectedReservation) {
                    this.updateClonedReservation(JSON.parse(JSON.stringify(this.getSelectedReservation)));
                    this.isReschedule = true;
                    this.loading = false;
                }
                else {
                    this.resetClonedReservation().then(() => {
                        this.loading = false;
                    });
                }
            },
            toggleAvailability: function() {
                this.isOpened = !this.isOpened;
            },
            addedEvent: function(event) {
                this.event = event;
            },
            book: function() {
                this.isBooking = true;
                this.resetClonedReservation().then(() => {
                    let clone = JSON.parse(JSON.stringify(this.getClonedReservation));
                    clone.event = this.event;

                    this.updateClonedReservation(clone).then(() => {
                        this.resetWindow();
                        this.$router.push({ name: 'pluralo.reservation.new' });
                    });

                    this.isBooking = false;
                });
            },
            reschedule: function() {
                const message = 'Are you sure you want to reschedule this reservation?';
                this.isBooking = true;
                this.$dialog.confirm(message)
                .then(() => {
                    this.doReschedule();
                    this.isBooking = false;
                })
                .catch(() => {
                    this.isBooking = false;
                });
            },
            doReschedule: function() {
                const rescheduled = JSON.parse(JSON.stringify(this.getClonedReservation));

                this.rescheduleReservation({
                    supplierId: this.account.supplierId,
                    deliverNotification: false,
                    event: rescheduled.event,
                    booking: rescheduled
                }).then(() => {
                    this.resetWindow();
                });
            },
            cancelReservation: function() {
                this.resetWindow();
            },
            resetWindow: function() {
                this.isOpened = false;
                this.resetSelectedReservation();
                this.resetLastSavedReservation();
                this.closeModal();
            },
            closeAvailability: function(opened) {
                this.isOpened = opened;
            }
        },
        components: {
            Modal,
            AddFilters,
            ProductsScroller,
            TimelineScroller,
            Availability,
            Events,
        }
    }
</script>


// WEBPACK FOOTER //
// ReservationAdd.vue?b85b437a